import { render, staticRenderFns } from "./PwaNewVoucher.vue?vue&type=template&id=36dcd77f&scoped=true"
import script from "./PwaNewVoucher.vue?vue&type=script&lang=js"
export * from "./PwaNewVoucher.vue?vue&type=script&lang=js"
import style0 from "./PwaNewVoucher.vue?vue&type=style&index=0&id=36dcd77f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36dcd77f",
  null
  
)

export default component.exports